import { REACT_APP_NAME_APP } from './core/hooks/enviroment';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import AppRoutes from './App.routes';

function App() {
  return (
    <div className="App">
      <Router basename={REACT_APP_NAME_APP}>
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
